"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconPhone = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var React = __importStar(require("react"));

exports.IconPhone = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, ["color"]);

  return (0, jsx_runtime_1.jsxs)("svg", _objectSpread(_objectSpread({
    width: "41",
    height: "40",
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef,
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M20.0016 0.000444432C9.0238 0.000444432 0.0891799 8.93506 0.000731518 19.8675C-0.0444083 25.2011 2.00082 30.2671 5.77877 34.0451C9.51155 37.8682 14.5343 39.9569 19.8678 40H20.0015C30.9793 40 39.914 31.0654 40.0024 20.1329C40.091 9.11152 31.1585 0.0884484 20.0015 0L20.0016 0.000444432ZM20.0016 37.2901H19.8679C15.2464 37.245 10.9333 35.4237 7.64517 32.1334C4.44538 28.8902 2.66761 24.534 2.71251 19.9124C2.75765 10.4449 10.536 2.71212 20.1351 2.71212C29.691 2.75726 37.3807 10.5787 37.3354 20.1347C37.2468 29.6022 29.4688 37.2901 20.0013 37.2901H20.0016Z",
      fill: color
    }, void 0), (0, jsx_runtime_1.jsx)("path", {
      d: "M27.9566 20.8449C27.4236 20.3119 26.6684 20.0012 25.9114 20.0012C25.111 20.0012 24.4009 20.3119 23.8661 20.8449L23.0658 21.6453C21.1994 20.3119 19.5552 18.6678 18.222 16.8015L19.0224 16.0012C19.5554 15.4682 19.8661 14.7129 19.8661 13.9559C19.8661 13.1555 19.5554 12.4454 19.0224 11.9107L16.4008 9.28904C15.8677 8.75604 15.1125 8.44527 14.3555 8.44527C13.5551 8.44527 12.845 8.75604 12.3103 9.28904L11.4213 10.178C9.68863 11.9107 8.22154 14.9333 11.1106 19.557C13.0655 22.7135 16.2219 25.4689 17.9113 26.8454C19.8229 28.401 21.8229 29.5122 23.8662 30.1337C24.5781 30.3559 25.2448 30.4445 25.8212 30.4445C27.2882 30.4445 28.4879 29.8663 29.7762 28.5781L30.6651 27.6892C31.1981 27.1562 31.5089 26.4009 31.5089 25.6439C31.5089 24.8435 31.1981 24.1334 30.6651 23.5987L27.9566 20.8449ZM28.8021 25.7794L27.9132 26.6683C26.9358 27.6458 26.3124 27.7795 25.7794 27.7795C25.4235 27.7795 25.0242 27.6909 24.5797 27.5572C22.8904 27.0242 21.1577 26.0901 19.4684 24.7567C16.7565 22.5796 14.534 20.2237 13.2459 18.1351C12.2233 16.491 11.1121 14.0464 13.2008 11.958L13.2459 11.9128L14.0897 11.069C14.1782 10.9805 14.2668 10.9805 14.3119 10.9805C14.357 10.9805 14.489 10.9805 14.5341 11.069L17.1558 13.6907C17.2443 13.7792 17.2443 13.8678 17.2443 13.9129C17.2443 13.958 17.2443 14.09 17.1558 14.1351L15.6001 15.6908C15.1557 16.1352 15.1105 16.8019 15.423 17.2915L15.4682 17.3367C17.2912 20.1372 19.6454 22.4934 22.4458 24.3143L22.491 24.3595C22.9806 24.6702 23.6907 24.6268 24.0918 24.1824L25.6474 22.6267C25.7359 22.5382 25.8245 22.5382 25.8696 22.5382C25.9147 22.5382 26.0467 22.5382 26.0918 22.6267L28.7135 25.2484C28.802 25.3369 28.802 25.4255 28.802 25.4706C28.802 25.5123 28.8906 25.6911 28.802 25.7796L28.8021 25.7794Z",
      fill: color
    }, void 0)]
  }), void 0);
});